var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeBorder = function SvgHomeBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.18446V17.5C19 18.3284 18.3284 19 17.5 19H14.5C13.6716 19 13 18.3284 13 17.5V12.5113C13 11.4068 12.1046 10.5113 11 10.5113H9C7.89543 10.5113 7 11.4068 7 12.5113V17.5C7 18.3284 6.32843 19 5.5 19H2.5C1.67157 19 1 18.3284 1 17.5V8.18271C1 7.54939 1.29996 6.9535 1.80866 6.57625L8.79726 1.39354C9.50399 0.869434 10.4702 0.86876 11.1777 1.39188L18.1891 6.57634C18.6991 6.95346 19 7.55016 19 8.18446Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHomeBorder;